const el = {
  actions: "Δράσεις",
  and: "και",
  cancel: "Ακύρωση",
  changeFilterMode: "Αλλαγή λειτουργίας φίλτρου",
  changeSearchMode: "Αλλαγή λειτουργίας αναζήτησης",
  clearFilter: "Εκκαθάριση φίλτρου",
  clearSearch: "Εκκαθάριση αναζήτησης",
  clearSelection: "Εκκαθάριση επιλογής",
  clearSort: "Εκκαθάριση ταξινόμησης",
  clickToCopy: "Κάντε κλικ για αντιγραφή",
  copy: "Αντιγραφή",
  collapse: "Κατάρρευση",
  collapseAll: "Κατάρρευση όλων",
  columnActions: "Ενέργειες στήλης",
  copiedToClipboard: "Αντιγραφή στο πρόχειρο",
  dropToGroupBy: "Αφήστε για να ομαδοποιηθεί κατά {column}",
  edit: "Επεξεργασία",
  expand: "Ανάπτυξη",
  expandAll: "Αναπτύξτε όλα",
  filterArrIncludes: "Περιλαμβάνει το",
  filterArrIncludesAll: "Περιλαμβάνει όλα",
  filterArrIncludesSome: "Περιλαμβάνει το",
  filterBetween: "Μεταξύ",
  filterBetweenInclusive: "Μεταξύ συμπεριλαμβανομένων",
  filterByColumn: "Φίλτρο κατά {column}",
  filterContains: "Περιέχει",
  filterEmpty: "Κενό",
  filterEndsWith: "Τελειώνει με",
  filterEquals: "Ισούται με",
  filterEqualsString: "Ισούται με",
  filterFuzzy: "Ασαφές",
  filterGreaterThan: "Μεγαλύτερο από",
  filterGreaterThanOrEqualTo: "Μεγαλύτερο από ή ίσο με",
  filterInNumberRange: "Ανάμεσα από",
  filterIncludesString: "Περιέχει",
  filterIncludesStringSensitive: "Περιέχει",
  filterLessThan: "Μικρότερο από",
  filterLessThanOrEqualTo: "Μικρότερο ή ίσο από",
  filterMode: "Λειτουργία φίλτρου: {filterType}",
  filterNotEmpty: "Not Empty",
  filterNotEquals: "Δεν ισούται",
  filterStartsWith: "Αρχίζει με",
  filterWeakEquals: "Ισούται με",
  filteringByColumn: "Φιλτράρισμα κατά {column} - {filterType} {filterValue}",
  goToFirstPage: "Μετάβαση στην πρώτη σελίδα",
  goToLastPage: "Μετάβαση στην τελευταία σελίδα",
  goToNextPage: "Μετάβαση στην επόμενη σελίδα",
  goToPreviousPage: "Μετάβαση στην προηγούμενη σελίδα",
  grab: "Πιάσε το",
  groupByColumn: "Ομαδοποίηση κατά {column}",
  groupedBy: "Ομαδοποίηση κατά ",
  hideAll: "Απόκρυψη όλων",
  hideColumn: "Απόκρυψη στήλης {column}",
  max: "Max",
  min: "Min",
  move: "Μετακίνηση",
  noRecordsToDisplay: "Δεν υπάρχουν εγγραφές προς εμφάνιση",
  noResultsFound: "Δεν βρέθηκαν αποτελέσματα",
  of: "του",
  or: "ή",
  pin: "Καρφίτσωμα",
  pinToLeft: "Καρφίτσωμα προς τα αριστερά",
  pinToRight: "Καρφίτσωμα προς τα δεξιά",
  resetColumnSize: "Επαναφορά μεγέθους στήλης",
  resetOrder: "Επαναφορά σειράς",
  rowActions: "Ενέργειες γραμμής",
  rowNumber: "#",
  rowNumbers: "Αριθμοί σειράς",
  rowsPerPage: "Γραμμές ανά σελίδα",
  save: "Αποθήκευση",
  search: "Αναζήτηση",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} των {rowCount} επιλεγμένων σειρών",
  select: "Επιλογή",
  showAll: "Εμφάνιση όλων",
  showAllColumns: "Εμφάνιση όλων των στηλών",
  showHideColumns: "Εμφάνιση/απόκρυψη στηλών",
  showHideFilters: "Εμφάνιση/απόκρυψη φίλτρων",
  showHideSearch: "Εμφάνιση/απόκρυψη αναζήτησης",
  sortByColumnAsc: "Ταξινόμηση κατά {column} αύξουσα",
  sortByColumnDesc: "Ταξινόμηση κατά {column} φθίνουσα",
  sortedByColumnAsc: "Ταξινόμηση κατά {column} αύξουσα",
  sortedByColumnDesc: "Ταξινόμηση κατά {column} φθίνουσα",
  thenBy: ", στη συνέχεια κατά ",
  toggleDensity: "Εναλλαγή πυκνότητας",
  toggleFullScreen: "Εναλλαγή πλήρους οθόνης",
  toggleSelectAll: "Εναλλαγή επιλογής όλων",
  toggleSelectRow: "Εναλλαγή γραμμής επιλογής",
  toggleVisibility: "Εναλλαγή ορατότητας",
  ungroupByColumn: "Κατάργηση ομαδοποίησης κατά {column}",
  unpin: "Ξεκαρφίτσωμα",
  unpinAll: "Αποσύνδεση όλων",
};

export default el;
